import { useEffect, useState } from 'react';
import { trapFocus } from '../utils/trapFocus';
import { CommandAction, formatHotkey, getCommandActions, isDialogOpen, isTypingTarget } from '../utils/useCommandActions';
import { getNavigationShortcuts } from './NavigationShortcuts';

const globalShortcuts = [
  { name: 'Search & Commands', hotkey: '/' },
  { name: 'Keyboard Shortcuts', hotkey: '?' },
];

const ShortcutHelp = () => {

  const [open, setOpen] = useState(false);
  const [pageActions, setPageActions] = useState<CommandAction[]>([]);

  useEffect(() => {
    const handleShortcuts = (event: KeyboardEvent) => {
      if (open && (event.key === 'Escape' || event.key === '?')) {
        setOpen(false);
        return;
      }

      // Ignore if in other inputs
      if (isTypingTarget(event)) {
        return;
      }

      if (event.key === '?' && !isDialogOpen()) {
        setPageActions(getCommandActions().filter(action => action.hotkey));
        setOpen(true);
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleShortcuts);
    return () => window.removeEventListener("keydown", handleShortcuts);
  });

  if (!open) return null;

  return <div
    className="global-search-overlay"
    onMouseDown={(e) => { if (e.target === e.currentTarget) setOpen(false); }}
  >
    <div
      className="card global-search-panel"
      role="dialog"
      aria-modal="true"
      aria-label="Keyboard shortcuts"
      tabIndex={-1}
      ref={(el) => el?.focus()}
      onKeyDown={trapFocus}
      style={{ outline: 'none' }}
    >
      <div className="card-header">Keyboard Shortcuts</div>
      <ul className="list-group list-group-flush global-search-results">
        {pageActions.length > 0 && <li className="list-group-item text-muted small">This Page</li>}
        {pageActions.map((action, index) => <li
          key={index}
          className="list-group-item d-flex justify-content-between align-items-center"
        >
          {action.name}
          <kbd>{formatHotkey(action.hotkey)}</kbd>
        </li>)}
        <li className="list-group-item text-muted small">Go To</li>
        {getNavigationShortcuts().map((shortcut, index) => <li
          key={index}
          className="list-group-item d-flex justify-content-between align-items-center"
        >
          {shortcut.name}
          <kbd>{formatHotkey(shortcut.hotkey)}</kbd>
        </li>)}
        <li className="list-group-item text-muted small">Global</li>
        {globalShortcuts.map((shortcut, index) => <li
          key={index}
          className="list-group-item d-flex justify-content-between align-items-center"
        >
          {shortcut.name}
          <kbd>{shortcut.hotkey}</kbd>
        </li>)}
      </ul>
      <div className="global-search-hints text-muted">
        <kbd>esc</kbd> close
      </div>
    </div>
  </div>;
}

export default ShortcutHelp;
